<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { Primitive } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';
import { type BadgeVariants, badgeVariants } from '.';

const props = defineProps<
  PrimitiveProps & {
    variant?: BadgeVariants['variant'];
    capitalize?: BadgeVariants['capitalize'];
    class?: HTMLAttributes['class'];
  }
>();

const delegatedProps = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <Primitive data-slot="badge" :class="cn(badgeVariants({ variant, capitalize }), props.class)" v-bind="delegatedProps">
    <slot />
  </Primitive>
</template>
